module.exports = __webpack_public_path__ + "static/media/yellow_triangle_arrow.24e8d549.svg";